// Api URL based on env

export const API_URL = "/api";

export const INTEREST_OPTIONS = [
  'interest_1',
  'interest_2',
  'interest_3',
  'interest_N'
];

export const DEFAULT_MAP_MARKER_COLOR = '#414141'
//Questo è il codice colore kerakoll
export const SHARED_MAP_MARKER_COLOR = '#87ad84'

export const DEFAULT_SCATTERMAP_DATA = {
  mean_coords: {
    latitude: 44.6471,
    longitude: 10.9252
  },
  zoom: 12,
  points: [],

};

export const CALENDAR_MODE = {
  DAILY: "daily",
  WEEKLY: "weekly",
  MONTHLY: "monthly"
}

export const DEFAULT_WORKSITE_CONSTRUCTION_OPTIONS = (intl) => {
  return [
    {
      value: "new", name: intl.formatMessage({
        id: "new",
      })
    },
    {
      value: "renovation", name: intl.formatMessage({
        id: "renovation",
      })
    }
  ]
};

export const WORKSITE_STATUS_CHOICES = [
  "planning",
  "design",
  "open",
  "closed",
  "deactivated",
];

export function customSort(a, b) {
  const indexA = WORKSITE_STATUS_CHOICES.indexOf(a.step);
  const indexB = WORKSITE_STATUS_CHOICES.indexOf(b.step);
  return indexA - indexB;
}

export const DEFAULT_WORKSITE_STATUS_OPTIONS = (intl) => WORKSITE_STATUS_CHOICES
  .filter((s) => s !== 'deactivated').map((c, idx) => ({
    value: idx + 1,
    name: intl.formatMessage({id: c})
  }));

export const DEFAULT_WORKSITE_STATUS_DATA = WORKSITE_STATUS_CHOICES
  .reduce(
  (prev, c, idx) => ({
    ...prev,
      [idx+1]: {
      step: c,
      flg_active: false,
      date: null,
      author: null,
        reason: '',
        id: idx+1
      }
  }),
  {}
);

export const VERTICALS_LIST = ['Professionale', 'Gestionale / Finanziario', 'Tecnico', 'Genius Lab']

export const VERTICALS_DESCRIPTION_LIST = {
  'Professionale': 'Dettagli sulle procedure e documenti per l’accesso agli incentivi fiscali',
  'Gestionale / Finanziario': 'Dettagli sulle procedure di cessione del credito e di accesso ai finanziamenti',
  'Tecnico': 'Dettagli e Caratteristiche tecniche soluzioni Kerakoll',
  'Genius Lab': "Dettagli sulle funzionalità dell'app Genius Lab"
}

export const defaultSearchFilter = 'Nessun filtro'

export const MACROTHEMES_TYPES = [
  {
    value: "Visibilità limitata agli utenti interni",
    label: "Visibilità limitata agli utenti interni",
    level: 1,
    kerakoll_name: 'admin'
  },
  {
    value: "Visibilità limitata ad utenti interni e agenti",
    label: "Visibilità limitata ad utenti interni e agenti",
    level: 2,
    kerakoll_name: 'agente'
  },
  {
    value: "Visibile a tutti",
    label: "Visibile a tutti",
    level: 3,
    kerakoll_name: 'progettista'
  }
]

export const RE_API_URL = "";

export const WORKSITE_REFERENCES_SECTIONS = {
  title: {type: 'string', required: true},
  subtitle: {type: 'string', required: true},
  project: {type: 'text', required: true},
  interventions: {type: 'items'},
  needs: {type: 'items'},
  description: {type: 'text', required: true},
  system_benefits: {type: 'items'}
}

export const WORKSITE_TECHNICAL_SHEET_SECTIONS = {
  year: {type: 'natural'},
  designer_dl: {type: 'string'},
  company_coordinator: {type: 'string'},
  executing_company: {type: 'string'},
  worksite_manager: {type: 'string'},
  kerakoll_consultants: {type: 'items', rows: 1},
  kerakoll_fields: {type: 'items', rows: 1},
  kerakoll_corporate_product_manager: {type: 'items', rows: 1},
  surface: {type: 'natural', um: true},
  products: {type: 'nested_items', rows: 1}
}

export const WORKSITE_REFERENCES_APPROVERS = [
  {
    name: 'progettista',
    roles: ['freelance', 'design_studio', 'enterprise'],
    dependencies: [],
    signature: true,
    multiple: false
  },
  {
    name: 'CS',
    roles: ['CS'],
    dependencies: ['progettista'],
    signature: false,
    multiple: true
  },
  {
    name: 'marketing',
    roles: ['CS'],
    dependencies: ['CS', 'progettista'],
    signature: false,
    multiple: false
  }
]

export const CROP_ASPECT_RATIO = 16 / 10;
export const CROP_ASPECT_RATIO_TOLERANCE = 0.01;

export const PROFILE_LOGO_ASPECT_RATIO = 16 / 4;

export const PROFILE_LOGO_ASPECT_RATIO_TOLERANCE = 0.1;


export const WORKSITE_DEACTIVATE_REASON_CODES = [
  'worksite_deactivate_reason_1',
  'worksite_deactivate_reason_2',
  'worksite_deactivate_reason_3'
];

export const SORT_OPTIONS_NOTES = [
  {name: 'show_from_newest_to_oldest', value: 'desc'},
  {name: 'show_from_oldest_to_newest', value: 'asc'},
]

export const SORT_OPTIONS_TASKS = [
  {name: 'show_from_newest_to_oldest_modified', value: 'desc'},
  {name: 'show_from_oldest_to_newest_modified', value: 'asc'},
]

const WORKSITE_TASK_STATUS = ["OPEN", "ACTIVE", "CLOSED", "APPROVED"];

export const WORKSITE_TASK_STATUS_OPTIONS = WORKSITE_TASK_STATUS.map(
  (ts) => ({ name: `task_status_${ts}`, value: ts })
);
